import { makeStyles, shorthands } from '@fluentui/react-components';

export const useStyles = makeStyles({
  container: {
    '& .cell-overlay-actions': {
      zIndex: 1,
      alignItems: 'end',
      justifyContent: 'end',
    },
  },
  actionButton: {
    ...shorthands.margin('6px'),
    marginLeft: '0px',

    '&:focus': {
      ...shorthands.border('1px', 'solid', '#FFFFFF'),
    },

    '&:hover': {
      backgroundColor: '#C4C4C4',
    },
  },
});
